import { render, staticRenderFns } from "./VerticalYearCalendar.vue?vue&type=template&id=4b41507e"
import script from "./VerticalYearCalendar.vue?vue&type=script&lang=js"
export * from "./VerticalYearCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports